import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SantaCasaCunha = styled.img`
  max-width: 223px;
  max-height: 64px;
  margin-bottom: 32px;
`;

export const LoginContainer = styled.div`
  width: 100% !important;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #d1d5db;
  padding: 32px;
  gap: 16px;
`;

export const LoginLabel = styled.label`
  width: 100%;
  max-height: 20px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  color: #4b5563;
`;

export const LoadingOverlayResponsive = styled.div`
  @media (max-width: 500px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
  }
`;
